module.exports = __webpack_public_path__ + "static/media/62.e1c5e50f.jpg";